import React from 'react';
import { Navigate } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';

import UsersDashboard from '~/views/components/Dashboards/UsersDashboard';
import NotFoundView from '~/views/errors/NotFoundView';

const routes = () => [
  // custom login form
  // {
  //   path: '/login',
  //   element: <ClerkAuth />,
  // },
  {
    path: 'login/*',
    element: (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          width: '100%',
        }}
      >
        <SignIn
          routing="hash"
          path={null}
          appearance={{
            variables: { colorPrimary: '#5e59f3' },
            elements: {
              footer: { display: 'none' },
            },
          }}
        />
      </div>
    ),
  },
  {
    path: '/dashboard',
    element: <UsersDashboard />,
  },
  {
    path: '/',
    children: [
      { path: '', element: <Navigate to="/dashboard" replace /> },
      { path: '404', element: <NotFoundView /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
];

export default routes;
